/* eslint-disable react/jsx-filename-extension */
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

const CUSTOMER_ILLUSTRATIONS = {
  'air-apps': (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/air-apps.png"
      alt=""
      loading="lazy"
    />
  ),
  zozofit: (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/zozofit.png"
      alt=""
      loading="lazy"
    />
  ),
  cardpointer: (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/cardpointer.png"
      alt=""
      loading="lazy"
    />
  ),
  dipsea: (
    <StaticImage
      className="max-w-[482px] md:max-w-[392px]"
      src="../images/customers/dipsea.png"
      alt=""
      loading="lazy"
    />
  ),
  mojo: (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/mojo.png"
      alt=""
      loading="lazy"
    />
  ),
  runna: (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/runna.png"
      alt=""
      loading="lazy"
    />
  ),
  'unscripted-photographers': (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/unscripted-photographers.png"
      alt=""
      loading="lazy"
    />
  ),
  oto: (
    <StaticImage
      className="max-w-[482px] md:max-w-[392px]"
      src="../images/customers/oto.png"
      alt=""
      loading="lazy"
    />
  ),
  done: (
    <StaticImage
      className="max-w-[449px] md:max-w-[392px]"
      src="../images/customers/done.png"
      alt=""
      loading="lazy"
    />
  ),
  mindset: (
    <StaticImage
      className="max-w-[450px] md:max-w-[392px]"
      src="../images/customers/mindset.png"
      alt=""
      loading="lazy"
    />
  ),
  foodvisor: (
    <StaticImage
      className="max-w-[449px] md:max-w-[392px]"
      src="../images/customers/foodvisor.png"
      alt=""
      loading="lazy"
    />
  ),
  audm: (
    <StaticImage
      className="max-w-[482px] md:max-w-[392px]"
      src="../images/customers/audm.png"
      alt=""
      loading="lazy"
    />
  ),
  marmelapp: (
    <StaticImage
      className="max-w-[480px] md:max-w-[392px]"
      src="../images/customers/marmelapp.png"
      alt=""
      loading="lazy"
    />
  ),
  vsco: (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/vsco.png"
      alt=""
      loading="lazy"
    />
  ),
  widgetsmith: (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/widgetsmith.png"
      alt=""
      loading="lazy"
    />
  ),
  pixery: (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/pixery.png"
      alt=""
      loading="lazy"
    />
  ),
  notion: (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/notion.png"
      alt=""
      loading="lazy"
    />
  ),
  speechify: (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/speechify.png"
      alt=""
      loading="lazy"
    />
  ),
  photoroom: (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/photoroom.png"
      alt=""
      loading="lazy"
    />
  ),
  v1sports: (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/v1sports.png"
      alt=""
      loading="lazy"
    />
  ),
  rapchat: (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/rapchat.png"
      alt=""
      loading="lazy"
    />
  ),
  'tapping-solution': (
    <StaticImage
      className="max-w-[448px] md:max-w-[392px]"
      src="../images/customers/tapping-solution.png"
      alt=""
      loading="lazy"
    />
  ),
  'open-ai': (
    <StaticImage
      className="max-w-[481px] md:max-w-[392px]"
      src="../images/customers/open-ai.png"
      alt=""
      loading="lazy"
    />
  ),
};

export default CUSTOMER_ILLUSTRATIONS;
